import { Routes } from '@angular/router';
import { PermissionScope } from '@src/app/shared/enums';
import { EulaComponent } from './core/auth/components/eula/eula.component';
import { authCanActivateChild, authGuard } from './core/auth/guards/auth.guard';
import { RouteScopeMap } from './core/auth/guards/route-scopes-map.model';
import { routeScopesGuard } from './core/auth/guards/route-scopes.guard';
import { routeScopesDynamicRedirectGuard } from './core/auth/guards/routes-scopes-dynamic-redirect.guard';
import { EulaOutletComponent } from './shared/components';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';

const routeScopeMap: RouteScopeMap[] = [
  { path: 'shipments', requiredScopes: [PermissionScope.READ_SHIPMENTS] },
  { path: 'facilities', requiredScopes: [PermissionScope.READ_FACILITIES,] },
  { path: 'data-sources', requiredScopes: [PermissionScope.READ_DEVICES, PermissionScope.READ_LABELS, PermissionScope.READ_SOURCE_GROUPS] },
  { path: 'admin', requiredScopes: [PermissionScope.READ_ADMIN_PANEL,] },
  { path: 'user-settings', requiredScopes: [] },
];

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard, routeScopesDynamicRedirectGuard,],
    canActivateChild: [authCanActivateChild],
    component: EulaOutletComponent,
    data: { routeScopeMap },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/shipments'
      },
      {
        path: 'shipments',
        canActivate: [routeScopesGuard],
        data: { requiredScopes: routeScopeMap[0].requiredScopes },
        loadChildren: () => import('./shipments/shipments.routes').then(m => m.SHIPMENTS_ROUTES)
      },
      {
        path: 'facilities',
        canActivate: [routeScopesGuard],
        data: { requiredScopes: routeScopeMap[1].requiredScopes },
        loadChildren: () => import('./facilities/facilities.routes').then(m => m.FACILITIES_ROUTES)
      },
      {
        path: 'data-sources',
        canActivate: [routeScopesGuard],
        data: {requiredScopes: routeScopeMap[2].requiredScopes},
        loadChildren: () => import('./data-sources/data-sources.routes').then(m => m.DATA_SOURCES_ROUTES)
      },
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then(m => m.ADMIN_ROUTES)
      },
      {
        path: 'user-settings',
        loadChildren: () => import('./user-settings/user-settings.routes').then(m => m.USER_SETTINGS_ROUTES)
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      },
    ]
  },
  {
    path: 'eula',
    canActivate: [authGuard],
    component: EulaComponent
  },
  {
    path: 'callback',
    redirectTo: 'shipments'
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  },
];
